import React, { useState, useEffect } from "react";
import { Button, Grid } from "@material-ui/core";
import FormControlComponent from "../../components/dashboard/form-control";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import Alert from "@material-ui/lab/Alert";
import MainTable from "./MainTable";
import MainCalendar from "./MainCalendar";
import NotesDisplay from "./NotesDisplay";
import JournalAddNote from "../journal/add-journal-note";
import CompareMain from "../compare/CompareMain";
import { useDispatch, useSelector } from "react-redux";
import { addUsers } from "../../store/actions/userAction";
// import Dialog from "screens/dialog/CustomizedDialog";
import SearchButton from "./SearchButton";
import Box from "@mui/material/Box";
import DownloadReportMain from "../Report/downloadReportMain";
import { DEFAULT_ALERT } from "utils/strings";
import { useNavigate } from "react-router-dom";
import { setWalkTestModal } from "../../store/actions/walkTestAction";
import { setName, setLastName, setProfile, setRole, setUserId, setEmail } from "../../store/actions/authActions";
import InsuranceStatementModal from "./insuranceStatement/InsuranceStatementModal";

export default function Dashboard() {
  const axios = useAxiosPrivate();
  const dispatch = useDispatch();
  const accessUser = useSelector((state) => state?.user);
  const authState = useSelector((state) => state?.auth);
  const selectedUserIds = accessUser?.data?.map((user) => user?.user_id);
  const navigate = useNavigate();

  const [insuranceModalOpen, setInsuranceModalOpen] = useState(false);
  
  
  const [pageSize, setPageSize] = useState(10);
  const [group, setGroup] = useState("");
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });
  const [groupData, setGroupData] = useState([]);
  const formName = "Pick Team";
  const [selectedDays, setSelectedDays] = useState([]);
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState({});
  const [date, setDate] = useState(new Date());
  const [noteDetails, setNoteDetails] = useState([]);
  const [readJournal, setReadJournal] = useState(false);
  const [members, setMembers] = useState([]);
  const [userValue, setUserValue] = useState([]);
  const [fData, setFData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [user, setUser] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [openDownloadReport, setOpenDownloadReport] = useState(false);

  const getJournalData = async (newMonth = null) => {
    
    let targetDate = newMonth || date;
    let month = ("0" + (targetDate.getMonth() + 1)).slice(-2);
  
    // Only fetch profile if we need groups and don't have them yet
    // NavBar should have already loaded profile data into Redux
    let groupsList = [];
    
    if (groupData.length === 0) {
      // Only call profile API if groups are not already loaded
      // This happens on initial load or if groups haven't been fetched yet
      try {
        const profile = await axios.get("/user/profile");
        const profileData = profile.data.data;
        
        // Update Redux store with profile data (in case NavBar hasn't loaded it yet)
        if (!authState.name || !authState.email) {
          dispatch(setName(profileData.first_name));
          dispatch(setLastName(profileData.last_name));
          dispatch(setRole(profileData.role));
          dispatch(setProfile(profileData.avatar_url));
          dispatch(setUserId(profileData.id));
          dispatch(setEmail(profileData.email));
        }
        
        groupsList = profileData.groups || [];
      } catch (error) {
        console.error("Error fetching profile for groups:", error);
        // If API fails, try to continue with empty groups
        groupsList = [];
      }
    } else {
      // Use existing groups, but remove the "All" item if it exists to get fresh groups
      groupsList = groupData.filter(g => g.id !== "").map(g => ({
        id: g.id,
        name: g.name,
        category: g.category,
        category_id: g.category_id,
        coach_id: g.coach_id,
        coach_name: g.coach_name,
      }));
    }
    
    const all = {
      id: "",
      name: "All",
      category: "All",
      category_id: "N/A",
      coach_id: "N/A",
      coach_name: "N/A",
    };
    // add item all to the beginning of the array
    groupsList.unshift(all);
    setGroupData(groupsList);
    
    const { data } = await axios.post(
      `/journal/${targetDate.getFullYear()}/${month}`,
      { group_id: group }
    );
    setNote(data.data);
    let getDays = [];
    for (const property in data.data) {
      getDays.push(property);
    }
    setSelectedDays(getDays);
  };

  const loadData = async (order, filed) => {
    try {
      const data = await axios.get(
        `/team/dashboard?page=${pageNumber}&page_size=${pageSize}&order=${order}&field=${filed}&group_id=${group}&search=${searchValue}`
      );
      setCount(data?.data?.total_pages);
      setTotalPages(data?.data?.total_pages);
      setTotalRecords(data?.data?.total_records);
      const dmember = data.data.data;
      setMembers(dmember);
      const users = dmember.map((user) => {
        return user.user_id;
      });
      setUser(users);
      setAlert(DEFAULT_ALERT);
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message:
          "You're not in a Team yet. Please ask your team admin to invite you in.",
      });
    }
  };

  const searchPlayers = async (order, filed) => {
    try {
      const data = await axios.get(
        `/team/dashboard?page=${pageNumber}&page_size=${pageSize}&order=${order}&field=${filed}&group_id=${group}&search=${searchValue}`
      );
      setCount(data?.data?.total_pages);
      setTotalPages(data?.data?.total_pages);
      setTotalRecords(data?.data?.total_records);
      
      const dmember = data.data.data;
      setMembers(dmember);
      const users = dmember.map((user) => {
        return user.user_id;
      });
      setUser(users);
      setAlert(DEFAULT_ALERT);
    } catch (error) {
      setAlert({
        showAlert: true,
        severity: "error",
        message:
          "You're not in a Team yet. Please ask your team admin to invite you in.",
      });
    }
  };

  useEffect(() => {
    // Clear selected users when the picked team changes
    dispatch(addUsers([]));
    getJournalData();
    // eslint-disable-next-line
  }, [group]);

  useEffect(() => {
    dispatch(addUsers([...userValue]));
    // eslint-disable-next-line
  }, [userValue]);

  useEffect(() => {
    if (searchValue?.length === 0) {
      searchPlayers("asc", "full_name");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  const handleWalkTestClick = async () => {
    await dispatch(setWalkTestModal(true));
    navigate("/reports");
  };

  return (
    <Grid container style={{ padding: "2rem" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} container>
        <Box sx={{ display: "flex", flex: 1 }}>
          <Box sx={{ display: "flex", flex: 1 }}>
            <Grid container spacing={1} alignItems={"center"}>
              <Grid item>
                <FormControlComponent
                  groupData={groupData}
                  setGroup={setGroup}
                  group={group}
                  formName={formName}
                />
              </Grid>
              <Grid item>
                <CompareMain
                  setSearchValue={setSearchValue}
                  setUserValue={setUserValue}
                />
              </Grid>
              <Grid item>
                <SearchButton
                  searchValue={searchValue}
                  searchPlayers={searchPlayers}
                />
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Grid container spacing={3} alignItems={"center"} style={{ paddingRight: "1.2rem" }}>
              <Grid item>
                <span
                  onClick={() => {
                    if (selectedUserIds?.length > 0)
                      setOpenDownloadReport(true);
                  }}
                  style={{
                    color: selectedUserIds?.length > 0 ? "#0F9BB0" : "#0F9BB0",
                    textDecorationLine:
                    selectedUserIds?.length > 0 ? "underline" : "underline",
                    fontSize: "0.85rem",
                    cursor: selectedUserIds?.length > 0 ? "pointer" : "not-allowed",
                    opacity: selectedUserIds?.length > 0 ? 1 : 0.6,
                    pointerEvents: selectedUserIds?.length > 0 ? "auto" : "none",
                  }}
                >
                  Download Report
                </span>
              </Grid>
              {/* <Grid item>
                <Dialog userValue={accessUser?.data} fData={fData} />
              </Grid> */}
            </Grid>
          </Box>
        </Box>
        <Box
          sx={{
            width: "340px",
            minWidth: "340px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "8px",
          }}
        >
           <Button
            variant="outlined"
            onClick={() => setInsuranceModalOpen(true)}
            style={{
              borderColor: "#0C8092",
              color: "#0C8092",
              textTransform: "none",
              fontFamily: "Poppins",
              fontSize: "11px",
              whiteSpace: "nowrap",
            }}
          >
            Insurance Statement
          </Button>
          <Button
            variant="contained"
            onClick={handleWalkTestClick}
            style={{
              backgroundColor: "#0F9BB0",
              color: "white",
              textTransform: "none",
              fontFamily: "Poppins",
              fontSize: "11px",
              whiteSpace: "nowrap",
            }}
          >
            6-Minute Walk Test
          </Button>
         
        </Box>
      </Grid>
      <Grid item xs={12} sm={12} md={12} container style={{ marginTop: ".28rem" }}>
        <Box sx={{ display: "flex", width: "100%", gap: "1rem", alignItems: "flex-start" }}>
          <Box sx={{ flex: "1", minWidth: 0, overflow: "hidden" }}>
            <MainTable
              accessUser={accessUser}
              group={group}
              getJournalData={getJournalData}
              members={members}
              fData={fData}
              setFData={setFData}
              loadData={loadData}
              count={count}
              user={user}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
              totalPages={totalPages}
              totalRecords={totalRecords}
              pageSize={pageSize}
              setPageSize={setPageSize}
            />
          </Box>
          <Box sx={{ 
            width: "340px",
            minWidth: "340px",
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "stretch",
            gap: "0.5rem",
            marginTop: ".28rem",
          }}>
            <MainCalendar
              selectedDays={selectedDays}
              date={date}
              setDate={setDate}
              getJournalData={getJournalData}
            />
            <NotesDisplay
              setOpen={setOpen}
              note={note}
              date={date}
              setNoteDetails={setNoteDetails}
              setReadJournal={setReadJournal}
            />
          </Box>
        </Box>
      </Grid>
      {alert.showAlert && (
        <Alert
          severity={alert.severity}
          onClose={() =>
            setAlert({
              ...alert,
              showAlert: false,
            })
          }
        >
          {alert.message}
        </Alert>
      )}

      <JournalAddNote
        getJournalData={getJournalData}
        selectedDate={date}
        noteDetails={noteDetails}
        readJournal={readJournal}
        setReadJournal={setReadJournal}
        setOpen={setOpen}
        open={open}
      />
      <DownloadReportMain
        setOpen={setOpenDownloadReport}
        open={openDownloadReport}
      />
      <InsuranceStatementModal
        open={insuranceModalOpen}
        onClose={() => setInsuranceModalOpen(false)}
      />
    </Grid>
  );
}
